import { useState, useEffect, useRef } from "react";
import { Skeleton } from "@mui/material";
import { Container } from "react-bootstrap";
import { Footer, NavBar, CountDown, TestimonialCarousel, VirtualRegistrationPricing } from "../components";
import { useResizeImg } from '../../../utils/useResizeImg';

import styles from './Registor.module.css'

const DESKTOP_IMG_URL = '../../../../assets/events/etvs23/register-banner-desktop.jpg'
const MOBILE_IMG_URL = '../../../../assets/events/etvs23/register-banner-mobile.jpg'
const deadline = new Date('May 4 2023 00:00:00 PST');
let discount = deadline > new Date() ? 200 : 100
export const Register = () => {
   document.title = "Emerging Tech Venture Summit | Register";

   const [isLoading, setIsLoading] = useState(true);
   const imageSource = useResizeImg(DESKTOP_IMG_URL, MOBILE_IMG_URL)
   const myDiv = useRef(null);


   useEffect(() => {
      var bz = document.createElement("script");
      bz.type = "text/javascript";
      bz.async = true;
      bz.src = "https://organizer.bizzabo.com/widgets/tickets/tickets.js";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(bz, s);
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);
      script.addEventListener('load', () => {
         if (window.hbspt) {
            window.hbspt.forms.create({
               portalId: '536350',
               formId: "8b0104df-57bf-4a46-bef7-b8e2b9fad4d1",
               region: "na1",
               target: '#preregForm'
            })
         }
      });
   }, []);
   return (
      <div className={styles.registor} style={{ backgroundColor: '#D1D1D1' }}>
         <NavBar myDiv={myDiv} />
         <Container className={styles.banner} fluid>
            {
               isLoading ?
                  <Skeleton animation="wave" variant="rectangular" sx={{ minHeight: '50vh', position: 'initial !important', backgroundColor: '#0F1A28' }}>
                     <div id="etxLoader" style={{ left: window.innerWidth > 900 ? '45%' : '40%', top: '40%' }} />
                     <img
                        onLoad={() => setIsLoading(false)}
                        src={imageSource}
                        alt='home-img'
                        style={{ visibility: 'hidden', minHeight: window.innerWidth > 1200 && "50vh", width: '100%' }}
                     />
                  </Skeleton>
                  : <img
                     src={imageSource}
                     loading="eager"
                     alt='register-banner'
                     style={{ minHeight: window.innerWidth > 1200 && "50vh", width: '100%' }}
                  />
            }
            {
               !isLoading &&
               <div className={styles.itemsOnBanner}>
                  <h2 >
                     <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_2_874)">
                           <path d="M83.6706 40.4044L72.1659 19.4693C68.5034 20.0565 64.6815 18.3855 62.56 15.0347L12.7694 42.3969C14.39 45.8441 13.8639 49.7858 11.648 52.5503L23.3042 73.761C25.9478 73.4699 28.6439 74.3304 30.6827 76.1448L81.4433 48.2496C80.9891 45.4093 81.8073 42.5225 83.6718 40.4088" fill="#E0BE23" />
                           <path d="M82.0657 39.9081L70.5593 18.9702C66.9017 19.5572 63.077 17.8877 60.9574 14.5359L11.1668 41.898C12.7849 45.3454 12.2627 49.285 10.0416 52.0536L21.6994 73.2672C24.3471 72.9701 27.038 73.8346 29.0749 75.6501L79.8412 47.7517C79.3858 44.9046 80.1978 42.0225 82.0668 39.9125" fill="#FFDD15" />
                           <path d="M41.4131 33.0145C41.4752 33.1237 41.5153 33.2441 41.5309 33.3687C41.5465 33.4934 41.5374 33.62 41.5042 33.7411C41.4709 33.8623 41.4141 33.9757 41.337 34.0749C41.2598 34.1741 41.1639 34.2572 41.0547 34.3193L19.2995 46.2748C19.1885 46.3342 19.0669 46.371 18.9416 46.3832C18.8163 46.3955 18.6898 46.3828 18.5695 46.346C18.4491 46.3092 18.3372 46.249 18.2401 46.1688C18.1431 46.0887 18.0628 45.9901 18.004 45.8788C17.7449 45.4073 17.9026 44.8229 18.3627 44.5701L40.116 32.6156C40.5741 32.3639 41.1525 32.5449 41.4111 33.0155L41.4131 33.0145ZM43.9354 37.6043C44.1945 38.0759 44.0348 38.6613 43.5786 38.912L21.8234 50.8675C21.7121 50.9267 21.5902 50.9633 21.4647 50.9753C21.3392 50.9873 21.2125 50.9744 21.092 50.9374C20.9715 50.9003 20.8595 50.8398 20.7624 50.7594C20.6653 50.679 20.5851 50.5801 20.5263 50.4686C20.464 50.3594 20.4238 50.2389 20.4083 50.1141C20.3927 49.9893 20.402 49.8626 20.4355 49.7414C20.4691 49.6202 20.5264 49.5069 20.6039 49.4079C20.6815 49.3089 20.7779 49.2262 20.8876 49.1647L42.6409 37.2102C42.7517 37.151 42.873 37.1142 42.998 37.1021C43.123 37.0899 43.2492 37.1025 43.3693 37.1392C43.4894 37.1759 43.601 37.236 43.6979 37.316C43.7947 37.396 43.8747 37.4943 43.9334 37.6053L43.9354 37.6043ZM40.8312 44.6458C40.998 44.9493 40.8612 45.3534 40.5183 45.5418L24.3363 54.4345C23.9973 54.6209 23.5819 54.5203 23.4151 54.2168C23.2436 53.9046 23.3852 53.5092 23.7252 53.3224L39.9081 44.4291C40.25 44.2412 40.6602 44.3347 40.8312 44.6458V44.6458ZM42.4748 47.6366C42.6431 47.9429 42.5037 48.3422 42.1608 48.5306L25.9788 57.4233C25.6398 57.6096 25.227 57.5139 25.0587 57.2075C24.8898 56.9002 25.0287 56.4999 25.3687 56.3131L41.5516 47.4199C41.8935 47.232 42.3053 47.3283 42.4748 47.6366V47.6366ZM44.2592 50.8837C44.4281 51.191 44.2886 51.5903 43.9458 51.7787L27.7638 60.6714C27.4248 60.8578 27.012 60.762 26.8431 60.4546C26.6737 60.1464 26.8121 59.7452 27.1521 59.5583L43.335 50.6651C43.6769 50.4772 44.0898 50.5754 44.2592 50.8837ZM45.9006 53.8706C46.0711 54.1808 45.9316 54.5801 45.5888 54.7685L29.4068 63.6612C29.0678 63.8475 28.655 63.7517 28.4845 63.4415C28.3167 63.1361 28.4562 62.7369 28.7962 62.55L44.9791 53.6568C45.321 53.4689 45.7328 53.5652 45.9006 53.8706ZM70.0002 40.6268C70.1707 40.937 70.0303 41.3368 69.6893 41.5241L53.5064 50.4174C53.1664 50.6042 52.7556 50.5074 52.5851 50.1972C52.4173 49.8918 52.5558 49.493 52.8958 49.3062L69.0787 40.413C69.4196 40.2256 69.8324 40.3214 70.0002 40.6268ZM68.7193 38.2959C68.8892 38.6051 68.7488 39.0049 68.4079 39.1923L52.2249 48.0855C51.8849 48.2724 51.4741 48.1755 51.3042 47.8663C51.1374 47.5628 51.2754 47.1631 51.6153 46.9762L67.7983 38.083C68.1392 37.8956 68.552 37.9914 68.7193 38.2959Z" fill="#4F666D" />
                        </g>
                        <defs>
                           <clipPath id="clip0_2_874">
                              <rect width="70.1363" height="70.1363" fill="white" transform="translate(0 33.7785) rotate(-28.7908)" />
                           </clipPath>
                        </defs>
                     </svg>
                     Get Your Tickets Now
                  </h2>
                  <div className={styles.countDown}>
                     <h2>Register Now and Save ${discount}!</h2>
                     <h3>Use Promo Code: early{discount}</h3>
                     <h6>Pre-registration savings available for a limited time</h6>
                     {deadline > new Date() && <CountDown deadline={deadline} />}
                  </div>
               </div>
            }

         </Container>
         <div ref={myDiv} style={{ height: '55px', width: '100%' }} />
         <VirtualRegistrationPricing discount={discount} />
         <h5>*Food will be available for purchase.</h5>
         <TestimonialCarousel bg={'linear-gradient(360deg, #200F28 0%, #0F1A28 100%)'} pageName={"registration;"} iconsColor={'#7A129E'} />

         <div
            id="biza-prc-div"
            className="bizzabo-tickets-widget"
            style={{ paddingRight: '15vw', paddingLeft: '15vw', marginTop: '4em' }}
            data-event-id="419957"
            data-params="isInMinisite=true&widgetId=235353"
         />
         <Footer />
      </div >
   );
};